import api from "@/lib/axios";

export const historyApi = {
    list: (params) =>
        api.get("/caregiver/history", { params }).then((r) => r.data),
};
